import { render, staticRenderFns } from "./checklist-lists.vue?vue&type=template&id=3ff3c4aa&scoped=true"
import script from "./checklist-lists.vue?vue&type=script&lang=js"
export * from "./checklist-lists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3c4aa",
  null
  
)

export default component.exports